import { render, staticRenderFns } from "./ModalSuspendedAccount.vue?vue&type=template&id=38f37fa6&scoped=true"
import script from "./ModalSuspendedAccount.vue?vue&type=script&lang=js"
export * from "./ModalSuspendedAccount.vue?vue&type=script&lang=js"
import style0 from "./ModalSuspendedAccount.vue?vue&type=style&index=0&id=38f37fa6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f37fa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f37fa6')) {
      api.createRecord('38f37fa6', component.options)
    } else {
      api.reload('38f37fa6', component.options)
    }
    module.hot.accept("./ModalSuspendedAccount.vue?vue&type=template&id=38f37fa6&scoped=true", function () {
      api.rerender('38f37fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalSuspendedAccount.vue"
export default component.exports